import * as React from 'react';
import { Input, Checkbox, Button, Row, Col, Modal } from 'antd';
import { FormItem } from '../../../../components/Form';
import CustomerGroupSelect from '../../../../components/Others/CustomerGroupSelect';
import CustomerGroup from 'src/scenes/CustomerGroup';

export interface IGeneralSettingsColProps {
  customer: GQL.ICustomer;
  onChange: Function;
  onTokenSave: Function;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {
  private changeToken(token, onChange, tokenSave) {
    Modal.confirm({
      title: token,
      content: <Input
        name={'jsonPricesDownloadToken'}
        defaultValue={token}
        onChange={e => onChange(e)}
      />,
      onOk: () => {
        tokenSave();
      },
      onCancel: () => onChange({ target: { name: 'jsonPricesDownloadToken', value: token }})
    });
  }

  public render() {
    const { customer } = this.props;
    let customerGroupsIdsForSelect:string[]= customer.customerGroupIds || []; // Je rozdíl mezi [string] a string[] - [string] nepovolí prázdné pole
    if(customer.customerGroups){
      customerGroupsIdsForSelect = [];
      customer.customerGroups.forEach((group) => {// možná použít customer.customerGroups.map((group) => group.id);
        if(`string` == typeof group){
          customerGroupsIdsForSelect.push(group);
          return;
        }
        customerGroupsIdsForSelect.push(group.id);
      });
    }

    return (
      <div>
        <FormItem label={'Last name'} required={true}>
          <Input
            name={'invoiceLastName'}
            autoFocus={true}
            placeholder="Last name"
            value={customer.invoiceLastName || ''}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'First name'} required={true}>
          <Input
            name={'invoiceFirstName'}
            placeholder="First name"
            value={customer.invoiceFirstName}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'E-mail'} required={true}>
          <Input
            name={'email'}
            placeholder="E-mail"
            value={customer.email}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Phone'} required={true}>
          <Input
            name={'phone'}
            placeholder="Phone"
            value={customer.phone || undefined}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Customer group'}>
          <CustomerGroupSelect
            name={'customerGroup'}
            value={customer.customerGroup ? customer.customerGroup.id : undefined}
            onChange={(e: any, customerGroup: GQL.ICustomerGroup) => this.props.onChange({ target: { name: 'customerGroup', value: customerGroup } })}
          />
        </FormItem>
        <FormItem label={'Customer groups'}>
          <CustomerGroupSelect
            name={'customerGroups'}
            value={customerGroupsIdsForSelect||undefined}
            onChange={(e: any, customerGroups: GQL.ICustomerGroup[]) => this.props.onChange({ target: { name: 'customerGroups', value: e.target.value } })}
            mode={"multiple"}
            placeholder={'Choose customer groups'}
          />
        </FormItem>
        <FormItem label={'Discount'}>
          <Input
            name={'discount'}
            type={'number'}
            placeholder="Discount"
            addonAfter={'%'}
            value={customer.discount || undefined}
            onChange={e => this.props.onChange({ target: { name: 'discount', value: parseFloat(e.target.value) } })}
          />
        </FormItem>
        
        <FormItem>
          <Checkbox
            name={'receiveNewsletter'}
            checked={customer.receiveNewsletter !== null && customer.receiveNewsletter !== undefined ? customer.receiveNewsletter : true}
            onChange={e => this.props.onChange(e)}
          >
            Receive newsletter
          </Checkbox>
        </FormItem>
        
        <FormItem>
          <Checkbox
            name={'saleTaxCertificate'}
            checked={customer.saleTaxCertificate !== null && customer.saleTaxCertificate !== undefined ? customer.saleTaxCertificate : false}
            onChange={e => this.props.onChange(e)}
          >
            Sale tax certificate
          </Checkbox>
        </FormItem>

        <FormItem>
          <Checkbox
            name={'inactive'}
            checked={customer.inactive !== null && customer.inactive !== undefined ? customer.inactive : false}
            onChange={e => this.props.onChange(e)}
          >
            <span style={{ color: 'red', fontWeight: 'bold' }}>Inactive</span>
          </Checkbox>
        </FormItem>

        <FormItem>
          <Row style={{alignItems: 'center'}}>
            <Col md={17}>
              JSON Download token: {customer.jsonPricesDownloadToken || ''}
            </Col>
            <Col md={5} >
              <Button
                onClick={() => this.changeToken(customer.jsonPricesDownloadToken || '', this.props.onChange, this.props.onTokenSave)}
              >
                Change token
              </Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem label={'Pohoda ID'} required={false}>
          <Input
            name={'pohodaCustomerId'}
            autoFocus={true}
            placeholder="Pohoda ID"
            value={customer.pohodaCustomerId || ''}
            required={false}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Customers/CustomerDetail/components/General.tsx